import { InjectedIntl } from 'react-intl';
import { action } from 'satcheljs';
import { SelfServePublisherActiveModel } from '../store/schema';

export const onInitializeProfilePage = action('onInitializeProfilePage', (publisherId: string, countryCode: string) => ({
  publisherId,
  countryCode,
}));

export const fetchPublisherProfileDetailsAction = action('fetchPublisherProfileDetailsAction', (publisherId: string) => ({ publisherId }));

export const fetchUserDetailsAction = action('fetchUserDetailsAction', (userId: number) => ({ userId }));

export const validateAddress = action(
  'validateAddress',
  (profile: SelfServePublisherActiveModel, formatMessage: InjectedIntl['formatMessage']) => ({ profile, formatMessage })
);

export const validateOrgAddress = action(
  'validateOrgAddress',
  (profile: SelfServePublisherActiveModel, formatMessage: InjectedIntl['formatMessage']) => ({ profile, formatMessage })
);
